import { Icon, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";
import "./RemoveFavoriteChip.scss";

const CROSS_ICON_SIZE = 10;

type RemoveFavoriteChipProps = {
    readonly busDisplayName: string;
    readonly onRemove: () => void;
};

// A floating circular close chip over a favorites row's top-right corner. The
// row reveals it on hover / focus-within.
const RemoveFavoriteChip: React.FC<RemoveFavoriteChipProps> = ({
    busDisplayName,
    onRemove
}) => (
    <span className="RemoveFavoriteChip">
        <Tooltip content="Remove" placement="bottom-end">
            <button
                type="button"
                className="RemoveFavoriteChip-button"
                aria-label={`Remove ${busDisplayName} from favorites`}
                // The row selects a bus on click, so the chip must not bubble.
                onClick={(event) => {
                    event.stopPropagation();
                    onRemove();
                }}
            >
                <Icon icon={IconNames.CROSS} size={CROSS_ICON_SIZE} />
            </button>
        </Tooltip>
    </span>
);

export default RemoveFavoriteChip;
